import React, { Component } from 'react';

import CodeAdd from './CodeAdd';
import CodeMod from './CodeMod';
import CodeDel from './CodeDel';

class CodeItem extends Component {
    render() {
        return (
            <tr>
                <td className="text-align-center">{this.props.codeItem.name}</td>
                <td className="text-align-center">{this.props.codeItem.code}</td>
                <td className="text-align-center">{this.props.codeItem.sort}</td>
                <td className="table-body-center">
                    <div className="component-align-center">
                        <CodeAdd stateRefresh={this.props.stateRefresh} name={this.props.codeItem.name} parentCode={this.props.codeItem.code} parentCodeName={this.props.codeItem.name} groupCode={this.props.codeItem.groupCode} groupCodeName={this.props.codeItem.groupCodeName} groupCodes={this.props.groupCodes}/>
                        <CodeMod stateRefresh={this.props.stateRefresh} codeItem={this.props.codeItem} groupCodes={this.props.groupCodes}/>
                        <CodeDel stateRefresh={this.props.stateRefresh} codeItem={this.props.codeItem}/>
                    </div>
                </td>
            </tr>
        )
    }
}

export default CodeItem;